/**
 * Proje genelinde kullanılan sabit değerler
 */

/** Shared primitives — semantic constants reference these; do not alias unrelated semantics to each other. */
export const STRING_TRUE = 'true';
export const LOGOUT = 'logout';
export const FORCE_LOGOUT = 'ForceLogout';
export const KEY_UNKNOWN = 'UNKNOWN';

export const AUTH_TOKEN_KEY = 'accessToken';
export const REFRESH_TOKEN_KEY = 'refreshToken';
export const USER_KEY = 'user';
/** Logout/session-end reason — survives clearStoredAuth so login page can re-print after redirect */
export const AUTH_SESSION_END_REASON_KEY = 'authSessionEndReason';
/** SignalR ForceLogout ile oturum kapatıldığında persist edilen reason kodu */
export const AUTH_SESSION_END_FORCE_LOGOUT = FORCE_LOGOUT;
/** Kullanıcının kendi logout işlemi */
export const AUTH_SESSION_END_USER_LOGOUT = 'UserLogout';
/** Token / refresh süresi veya auth reddi */
export const AUTH_SESSION_END_EXPIRED = 'SessionExpired';
/** Interceptor / token yenileme soft-fail hata mesajı */
export const AUTH_ERROR_SESSION_EXPIRED = 'Oturum süresi doldu';
/** Sekme görünür olunca access bitişine bu süreden az kaldıysa zorla yenile */
export const AUTH_VISIBILITY_FORCE_REFRESH_MS = 2 * 60 * 1000;
export const LAST_SELECTED_DESIGN_PROJECT_TYPE_KEY = 'lab_last_design_project_type';

// Lab Design Project Type Keys & Keywords
export const DESIGN_PROJECT_TYPE_KEY_UNKNOWN = KEY_UNKNOWN;
export const DESIGN_PROJECT_TYPE_KEY_VENEER = 'VENEER';
export const DESIGN_PROJECT_TYPE_KEY_CROWN = 'CROWN';
export const DESIGN_PROJECT_TYPE_KEY_BAR = 'BAR';

/** CAD hash route for Autobar (Bar) viewer — no leading slash. Also used as Bar type keyword. */
export const CAD_AUTOBAR_ROUTE_PATH = 'bar';

export const DESIGN_PROJECT_TYPE_KEYWORDS_VENEER = ['1', 'veneer', 'lamina'] as const;
export const DESIGN_PROJECT_TYPE_KEYWORDS_CROWN = ['2', 'crown', 'kuron'] as const;
export const DESIGN_PROJECT_TYPE_KEYWORDS_BAR = ['3', CAD_AUTOBAR_ROUTE_PATH] as const;

// Lab Design Project Status Keys & CSS Classes
export const DESIGN_PROJECT_STATUS_KEY_DRAFT = 'DRAFT';
export const DESIGN_PROJECT_STATUS_KEY_IN_PROGRESS = 'IN_PROGRESS';
export const DESIGN_PROJECT_STATUS_KEY_READY = 'READY';
export const DESIGN_PROJECT_STATUS_KEY_UNKNOWN = KEY_UNKNOWN;

export const DESIGN_PROJECT_STATUS_CSS_DRAFT = 'status-draft';
export const DESIGN_PROJECT_STATUS_CSS_IN_PROGRESS = 'status-in-progress';
export const DESIGN_PROJECT_STATUS_CSS_READY = 'status-ready';
export const DESIGN_PROJECT_STATUS_CSS_UNKNOWN = 'status-unknown';

export const DESIGN_PROJECT_STATUS_CHIP_CSS_DRAFT = 'design-project-status-draft';
export const DESIGN_PROJECT_STATUS_CHIP_CSS_IN_PROGRESS = 'design-project-status-in-progress';
export const DESIGN_PROJECT_STATUS_CHIP_CSS_READY = 'design-project-status-ready';
export const DESIGN_PROJECT_STATUS_CHIP_CSS_UNKNOWN = 'design-project-status-unknown';

export const DESIGN_PROJECT_STATS_KEY_INDEPENDENT = 'INDEPENDENT';

export const I18N_DESIGN_PROJECT_STATUS_PREFIX = 'DESIGN_PROJECTS.STATUS.';
export const I18N_DESIGN_PROJECT_STATS_PREFIX = 'DESIGN_PROJECTS.STATS.';

// Cookie İsimleri (token key'leri storage ile aynı — literal tekrarlanmaz)
export const ACCESS_TOKEN_COOKIE = AUTH_TOKEN_KEY;
export const REFRESH_TOKEN_COOKIE = REFRESH_TOKEN_KEY;
export const REFRESH_TOKEN_EXPIRES_COOKIE = 'refreshTokenExpired';
export const TOKEN_EXPIRES_COOKIE = 'expiration';
export const EMAIL_COOKIE = 'email';
export const LANGUAGE_COOKIE = 'language';
export const ACCOUNT_APP_URL_COOKIE = 'accountAppUrl';
export const BAR_GEO_HIDE_TUTORIALS_COOKIE = 'bar_geo_hide_tutorials';
export const AUTH_PARAM_REDIRECT_TEST_URL = 'redirectTestUrl';
export const AUTH_PARAM_TOKEN = 'token';
/** CAD deep-link query key for design project id */
export const AUTH_PARAM_PROJECT = 'project';


// BroadcastChannel constants for cross-tab communication
export const AUTH_BROADCAST_CHANNEL = 'dental-ui-auth';
export const LOGOUT_EVENT = LOGOUT;
export const LOGIN_EVENT = 'login';
/**
 * Cross-origin logout sync cookie (lab/cad/account farklı origin — BroadcastChannel yetmez).
 * Value: `${reason}|${epochMs}`
 */
export const AUTH_LOGOUT_BEACON_COOKIE = 'authLogoutBeacon';
/** Cross-origin logout beacon poll interval (ms) */
export const AUTH_LOGOUT_BEACON_POLL_MS = 2000;
/** Logout beacon cookie TTL (days) */
export const AUTH_LOGOUT_BEACON_TTL_DAYS = 1;
/** Separator between reason and epoch in beacon cookie value */
export const AUTH_LOGOUT_BEACON_VALUE_SEPARATOR = '|';

/** Login URL query/hash param that triggers local session clear */
export const AUTH_QUERY_LOGOUT = LOGOUT;
export const AUTH_QUERY_LOGOUT_VALUE = STRING_TRUE;
export const AUTH_REDIRECT_MODE_MODULE = 'module';

/** Default app entry paths (no leading slash — AppNavigation / openApplication) */
export const APP_ENTRY_PATH_MAIN = 'main';
export const LAB_ENTRY_PATH_DEV = APP_ENTRY_PATH_MAIN;
export const LAB_ENTRY_PATH_RELEASE = 'design-projects';

/** Fallback stem when export file name cannot be derived */
export const EXPORT_DEFAULT_MESH_STEM = 'mesh';

// SignalR MessageHub
export const SIGNALR_MESSAGE_HUB_PATH = 'messagehub';
export const SIGNALR_METHOD_JOIN_CONNECTION = 'JoinConnection';
export const SIGNALR_EVENT_FORCE_LOGOUT = FORCE_LOGOUT;
export const SIGNALR_EVENT_GET_ALL_NOTIFICATION = 'GetAllNotificationAsync';
export const SIGNALR_EVENT_SEND_MESSAGE_TO_GROUP = 'SendMessageToGroup';

// Auth Redirect Modları
export type AuthRedirectMode =
  | typeof LOGIN_EVENT
  | typeof LOGOUT_EVENT
  | typeof AUTH_REDIRECT_MODE_MODULE;

// Auth parametreleri - URL parametrelerinde ve temizliğinde kullanılan anahtarlar
export const AUTH_PARAM_KEYS = [
  AUTH_TOKEN_KEY,
  REFRESH_TOKEN_KEY,
  REFRESH_TOKEN_EXPIRES_COOKIE,
  TOKEN_EXPIRES_COOKIE,
  EMAIL_COOKIE,
  LANGUAGE_COOKIE,
  ACCOUNT_APP_URL_COOKIE,
  AUTH_PARAM_REDIRECT_TEST_URL,
  AUTH_PARAM_TOKEN,
] as const;

// Regex Patterns
export const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
/** Accepts local TR, national (0...), or E.164 (+90...) forms; storage should use toE164Phone(). */
export const PHONE_PATTERN = /^(\+\d{1,3}|0)?\s*[1-9]\d{2}\s*\d{3}\s*\d{2}\s*\d{2}$/;


// Account app constants
export const ACCOUNT_APP_NAME = 'account';
export const ACCOUNT_APP_SUBDOMAIN = ACCOUNT_APP_NAME;
export const ACCOUNT_APP_DISPLAY_NAME = 'Account';
export const ACCOUNT_ENTRY_PATH = ACCOUNT_APP_NAME;
export const ACCOUNT_SUBSCRIPTIONS_PATH = `${ACCOUNT_APP_NAME}/subscriptions`;
export const ROLE_ACCOUNT_MANAGER = 'AccountManager';

/** Compact role keys (API Role.description variants — EN/TR/legacy). */
export const ROLE_KEY_ACCOUNT_MANAGER = 'ACCOUNTMANAGER';
export const ROLE_KEY_HESAP_YONETICISI = 'HESAPYONETICISI';
export const ROLE_KEY_LABORATORY_MANAGER = 'LABORATORYMANAGER';
export const ROLE_KEY_LAB_MANAGER = 'LABMANAGER';
export const ROLE_KEY_TECHNICIAN = 'TECHNICIAN';
export const ROLE_KEY_DENTAL_TECHNICIAN = 'DENTALTECHNICIAN';
export const ROLE_KEY_TEKNISYEN = 'TEKNISYEN';

export const ACCOUNT_MANAGER_ROLE_KEYS = new Set([
  ROLE_KEY_ACCOUNT_MANAGER,
  ROLE_KEY_HESAP_YONETICISI,
  ROLE_KEY_LABORATORY_MANAGER,
  ROLE_KEY_LAB_MANAGER,
]);

export const TECHNICIAN_ROLE_KEYS = new Set([
  ROLE_KEY_TECHNICIAN,
  ROLE_KEY_DENTAL_TECHNICIAN,
  ROLE_KEY_TEKNISYEN,
]);

export const ORGANIZATION_ROLE_KEYS = new Set([
  ...ACCOUNT_MANAGER_ROLE_KEYS,
  ...TECHNICIAN_ROLE_KEYS,
]);

export const I18N_USERS_ROLE_ACCOUNTMANAGER = 'USERS.ROLE_ACCOUNTMANAGER';
export const I18N_USERS_ROLE_TECHNICIAN = 'USERS.ROLE_TECHNICIAN';
export const I18N_USERS_ROLE_NOTE_ACCOUNT_MANAGER = 'USERS.ROLE_NOTE_ACCOUNT_MANAGER';
export const I18N_USERS_ROLE_NOTE_TECHNICIAN = 'USERS.ROLE_NOTE_TECHNICIAN';

export const CLINIC_APP_NAME = 'clinic';
export const CLINIC_APP_SUBDOMAIN = CLINIC_APP_NAME;
export const CLINIC_APP_DISPLAY_NAME = 'Clinic';

export const LANDING_APP_NAME = 'landing';
export const LANDING_APP_SUBDOMAIN = LANDING_APP_NAME;
export const LANDING_APP_DISPLAY_NAME = 'Landing';

export const PORTAL_APP_NAME = 'portal';
export const PORTAL_APP_SUBDOMAIN = PORTAL_APP_NAME;
export const PORTAL_APP_DISPLAY_NAME = 'Portal';

export const CAD_APP_NAME = 'cad';
export const CAD_APP_SUBDOMAIN = CAD_APP_NAME;
export const CAD_APP_DISPLAY_NAME = 'CAD';

export const LAB_APP_NAME = 'lab';
export const LAB_APP_SUBDOMAIN = LAB_APP_NAME;
export const LAB_APP_DISPLAY_NAME = 'Lab';

export const AUTOBAR_BRAND_NAME = 'Autobar';
export const AUTOBAR_DEV_TITLE_SUFFIX = '[DEV]';

/** Browser tab title: `Autobar Lab`, `Autobar Lab [DEV]`. */
export function autobarDocumentTitle(appDisplayName?: string | null, isDev = false): string {
  const trimmed = (appDisplayName || '').trim();
  const base = trimmed ? `${AUTOBAR_BRAND_NAME} ${trimmed}` : AUTOBAR_BRAND_NAME;
  return isDev ? `${base} ${AUTOBAR_DEV_TITLE_SUFFIX}` : base;
}


/**
 * Uygulama tipini belirler (clinic veya lab)
 * @returns 1: clinic, 2: lab
 */
export function getDefaultServiceType(): number {
  if (typeof window === 'undefined') {
    return 1; // Server-side rendering için varsayılan clinic
  }

  const hostname = window.location.hostname.toLowerCase();
  const pathname = window.location.pathname.toLowerCase();

  // Lab uygulaması kontrolü
  if (hostname.includes('lab') || pathname.includes('/lab') || pathname.startsWith('/lab')) {
    return 2; // Laboratory
  }

  return 1; // Clinic (varsayılan)
}

/**
 * Uygulama ismine göre appType değerini döndürür
 * @param appName - Uygulama ismi (clinic, lab, cadcam)
 * @returns AppType değeri: 1: clinic, 2: lab, 3: cadcam, 0: tanımsız
 */
export function getAppTypeByName(appName: string): number {
  if (appName === CLINIC_APP_NAME) {
    return 1;
  } else if (appName === LAB_APP_NAME) {
    return 2;
  } else if (appName === CAD_APP_NAME) {
    return 3;
  }
  return 0;
}

/** Normalize role strings from API (EN/TR, diacritics, spaces, hyphens). */
export function compactRoleKey(role: string | null | undefined): string {
  return (role || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/İ/g, 'I')
    .replace(/ı/g, 'I')
    .toUpperCase()
    .replace(/[\s_-]/g, '');
}

const CLINIC_APP_ROLE_KEYS = new Set([
  'DENTIST',
  'CLINICMANAGER',
  'CLINICASSISTANT',
  'CLINICSECRETARY',
  'FINANCEOFFICER',
]);

const LAB_APP_ROLE_KEYS = new Set([
  ...ORGANIZATION_ROLE_KEYS,
]);

const CAD_APP_ROLE_KEYS = new Set(['DESIGNER', 'CADUSER']);

/**
 * Post-login appType from role: 1 clinic · 2 lab · 3 cad · 0 unknown.
 */
export function resolveAppTypeFromRole(role: string | null | undefined): number {
  const key = compactRoleKey(role);
  if (CLINIC_APP_ROLE_KEYS.has(key)) {
    return 1;
  }
  if (LAB_APP_ROLE_KEYS.has(key)) {
    return 2;
  }
  if (CAD_APP_ROLE_KEYS.has(key)) {
    return 3;
  }
  return 0;
}

/** Only clinic roles may land on Clinic after login (incl. redirect=clinic). */
export function canAccessClinicByRole(role: string | null | undefined): boolean {
  return resolveAppTypeFromRole(role) === 1;
}

// CAD Project Types
export const CAD_PROJECT_TYPE_DEFAULT = 0;
export const CAD_PROJECT_TYPE_VENEER = 1;
export const CAD_PROJECT_TYPE_CROWN = 2;
export const CAD_PROJECT_TYPE_BAR = 3;

// CAD Mesh Names
export const MESH_NAME_INPUT = 'inputMesh';
export const MESH_NAME_OUTPUT = 'outputMesh';
export const MESH_NAME_BASE_BAR = 'baseBar';
export const MESH_NAME_BAR_TOP = 'barTop';
export const MESH_NAME_BAR_BOTTOM = 'barBottom';
export const MESH_NAME_TOP_MESH = 'TopMesh';
export const MESH_NAME_BOTTOM_MESH = 'BottomMesh';
export const MESH_NAME_SPLIT_SURFACE = 'splitSurface';
export const MESH_NAME_EXTENDED_SURFACE = 'extendedSurface';
export const MESH_NAME_TEMPORARY_SURFACE = 'TemporarySurface';
export const MESH_NAME_CONES = 'Cones';
export const MESH_NAME_HOLES = 'Holes';
export type BarGroupType = typeof MESH_NAME_BAR_TOP | typeof MESH_NAME_BAR_BOTTOM;
export const MESH_NAME_BAR_TOP_PREFIX = `${MESH_NAME_BAR_TOP}_`;
export const MESH_NAME_BAR_BOTTOM_PREFIX = `${MESH_NAME_BAR_BOTTOM}_`;
export const LEGACY_MESH_NAME_TOP_MESH = 'topMesh';
export const LEGACY_MESH_NAME_BOTTOM_MESH = 'bottomMesh';
export const LEGACY_MESH_NAME_TOP_MESH_PREFIX = `${LEGACY_MESH_NAME_TOP_MESH}_`;
export const LEGACY_MESH_NAME_BOTTOM_MESH_PREFIX = `${LEGACY_MESH_NAME_BOTTOM_MESH}_`;

// CAD Case Detail Keys (same wire values as mesh names where they match)
export const CASE_DETAIL_KEY_INPUT_MESH = MESH_NAME_INPUT;
export const CASE_DETAIL_KEY_OUTPUT_MESH = MESH_NAME_OUTPUT;
export const CASE_DETAIL_KEY_BASE_BAR = MESH_NAME_BASE_BAR;
export const CASE_DETAIL_KEY_BAR_TOP = MESH_NAME_BAR_TOP;
export const CASE_DETAIL_KEY_BAR_BOTTOM = MESH_NAME_BAR_BOTTOM;
export const CASE_DETAIL_KEY_BAR_TOP_PARTS = 'barTopParts';
export const CASE_DETAIL_KEY_BAR_BOTTOM_PARTS = 'barBottomParts';
export const CASE_DETAIL_KEY_SPLIT_SURFACE = MESH_NAME_SPLIT_SURFACE;
export const CASE_DETAIL_KEY_CURVE_FILE = 'curveFile';
export const CASE_DETAIL_KEY_MESH_FILES = 'meshFiles';
export const CASE_DETAIL_KEY_CONES = 'cones';

// CAD Mesh Name Prefixes & Identifiers (lowercase forms of mesh names for case-insensitive match)
export const MESH_PREFIX_INPUT = MESH_NAME_INPUT.toLowerCase();
export const MESH_PREFIX_OUTPUT = MESH_NAME_OUTPUT.toLowerCase();
export const MESH_PREFIX_BASE_BAR = MESH_NAME_BASE_BAR.toLowerCase();
export const MESH_PREFIX_SPLIT_SURFACE = MESH_NAME_SPLIT_SURFACE.toLowerCase();
export const MESH_PREFIX_EXTENDED_SURFACE = MESH_NAME_EXTENDED_SURFACE.toLowerCase();
export const MESH_PREFIX_TEMPORARY = 'temporary';
export const MESH_PREFIX_HOLES = MESH_NAME_HOLES.toLowerCase();
export const MESH_PREFIX_TOP_MESH = MESH_NAME_TOP_MESH.toLowerCase();
export const MESH_PREFIX_BOTTOM_MESH = MESH_NAME_BOTTOM_MESH.toLowerCase();
export const MESH_PREFIX_BAR_TOP = MESH_NAME_BAR_TOP.toLowerCase();
export const MESH_PREFIX_BAR_BOTTOM = MESH_NAME_BAR_BOTTOM.toLowerCase();
export const MESH_PREFIX_CONE = 'cone';
export const MESH_PREFIX_CONES = MESH_NAME_CONES.toLowerCase();

export const STAGE_MESH_PREFIXES = [
  MESH_PREFIX_SPLIT_SURFACE,
  MESH_PREFIX_HOLES,
  MESH_PREFIX_TOP_MESH,
  MESH_PREFIX_BOTTOM_MESH,
  MESH_PREFIX_BAR_TOP,
  MESH_PREFIX_BAR_BOTTOM,
] as const;

export const CONE_NAME_REGEX = /^cone\d+$/i;
export const DEFAULT_MESH_FORMAT = 'stl';
export const FILE_EXTENSION_STL = `.${DEFAULT_MESH_FORMAT}`;
export const FILE_NAME_SPLIT_SURFACE_STL = `${MESH_NAME_SPLIT_SURFACE}${FILE_EXTENSION_STL}`;
export const FILE_NAME_BAR_TOP_STL = `${MESH_NAME_BAR_TOP}${FILE_EXTENSION_STL}`;
export const FILE_NAME_BAR_BOTTOM_STL = `${MESH_NAME_BAR_BOTTOM}${FILE_EXTENSION_STL}`;

/** Mesh name/fileName splitSurface mi (GUID fileName + name=splitSurface). */
export function isSplitSurfaceMeshName(value: string | undefined | null): boolean {
  if (!value) return false;
  const clean = value.trim().toLowerCase().replace(/\.stl$/i, '');
  return clean === MESH_PREFIX_SPLIT_SURFACE || clean.startsWith(`${MESH_PREFIX_SPLIT_SURFACE}_`);
}

// CAD Display Texts
export const DISPLAY_TEXT_RESTORATION = 'Restoration';
export const DISPLAY_TEXT_INPUT_MESH = DISPLAY_TEXT_RESTORATION;
export const DISPLAY_TEXT_OUTPUT_MESH = 'Output Mesh';
export const DISPLAY_TEXT_BASE_BAR = 'Base Bar';
export const DISPLAY_TEXT_TOP_BAR = 'Top Bar';
export const DISPLAY_TEXT_BOTTOM_BAR = 'Bottom Bar';
export const DISPLAY_TEXT_SPLIT_SURFACE = 'Split Surface';
export const DISPLAY_TEXT_EXTENDED_SURFACE = 'Extended Surface';

// CAD Commands & Formats
export const COMMAND_EXTRUDE = 'EXTRUDE';
export const COMMAND_SPLIT_MESH = 'SPLIT_MESH';
export const COMMAND_SET_OPACITY = 'SET_OPACITY';
export const COMMAND_SAVE_FILE = 'SAVE_FILE';
export const COMMAND_SAVE_BAR_CASE = 'SAVE_BAR_CASE';
export const COMMAND_SAVE_CASE = 'SAVE_CASE';
export const COMMAND_REQUEST_BAR_JSON = 'REQUEST_BAR_JSON';
export const COMMAND_MODIFIED_MESH = 'MODIFIED_MESH';
export const COMMAND_SET_EXTRUDE_DIR = 'SET_EXTRUDE_DIR';
export const COMMAND_GENERATE_CONE = 'GENERATE_CONE';
export const COMMAND_CONE_EDIT = 'CONE_EDIT';
export const COMMAND_SET_INTERACTION_MODE = 'SET_INTERACTION_MODE';
export const COMMAND_SHOW_MESH_PROXIMITY = 'SHOW_MESH_PROXIMITY';
export const COMMAND_RESOLVE_MESH_PROXIMITY = 'RESOLVE_MESH_PROXIMITY';
export const COMMAND_HIDE_MESH_PROXIMITY = 'HIDE_MESH_PROXIMITY';
export const COMMAND_CUT_MESH_BY_PLANE = 'CUT_MESH_BY_PLANE';
/** CAD viewer: mesh section clip plane (`action`: start | stop) */
export const COMMAND_MESH_SECTION = 'MESH_SECTION';
export const MESH_SECTION_ACTION_START = 'start';
export const MESH_SECTION_ACTION_STOP = 'stop';
export const COMMAND_ZOOM_TO_FIT = 'ZOOM_TO_FIT';
export const COMMAND_TOGGLE_WIREFRAME = 'TOGGLE_WIREFRAME';
export const COMMAND_TOGGLE_GRID = 'TOGGLE_GRID';
export const COMMAND_LOOK = 'LOOK';
export const COMMAND_LOAD_BAR_CASE = 'LOAD_BAR_CASE';
export const COMMAND_LOAD_CROWN_CASE = 'LOAD_CROWN_CASE';
export const COMMAND_LOAD_VIEWER_CASE = 'LOAD_VIEWER_CASE';
export const COMMAND_LOAD_VIEWER_CASE_BAR = 'LOAD_VIEWER_CASE_BAR';
export const COMMAND_LOAD_VIEWER_CASE_CROWN = 'LOAD_VIEWER_CASE_CROWN';
export const COMMAND_LOAD_VIEWER_CASE_VENEER = 'LOAD_VIEWER_CASE_VENEER';
export const COMMAND_LOAD_BAR_SUPPORT_MESH = 'LOAD_BAR_SUPPORT_MESH';
export const COMMAND_REMOVE_BAR_SUPPORT_MESH = 'REMOVE_BAR_SUPPORT_MESH';
export const COMMAND_SET_MOUSE_PRESET = 'SET_MOUSE_PRESET';
export const WASM_VALUE_KEY_MOUSE_PRESET = 'mousePreset';

// CAD Cone Opacity Levels
export const CONE_OPACITY_HIDDEN = 0;
export const CONE_OPACITY_APPLY = 60;

// CAD WASM Message Data Constants
export const WASM_MSG_DATA_CURVE = 'CURVE';
export const WASM_MSG_DATA_CURVELOOPISOPEN = 'CURVELOOPISOPEN';

// CAD Interaction Modes
export const INTERACTION_MODE_NONE = 'NONE';
export const INTERACTION_MODE_HIGHLIGHT = 'HIGHLIGHT';
export const INTERACTION_MODE_DEFINE_PLANE = 'DEFINE_PLANE';
export const INTERACTION_MODE_SMOOTH_MESH = 'SMOOTH_MESH';

// CAD Bar Geo Settings Tabs
export const BAR_GEO_TAB_SETTINGS = 'settings';
export const BAR_GEO_TAB_DEFORM = 'deform';
export const BAR_GEO_TAB_TOOLS = 'tools';

// CAD Deform Tool Modes
export const DEFORM_TOOL_SMOOTH = 'smooth';
export const DEFORM_TOOL_SUBTRACT = 'subtract';
export const DEFORM_TOOL_INFLATE = 'inflate';
export const DEFORM_TOOL_GRAB = 'grab';

// CAD Bar Schematic Parameter Keys
export const BAR_SCHEMATIC_PARAM_ANGLE_1 = 'angle1';
export const BAR_SCHEMATIC_PARAM_ANGLE_2 = 'angle2';
export const BAR_SCHEMATIC_PARAM_RADIUS_1 = 'radius1';
export const BAR_SCHEMATIC_PARAM_LEN_1 = 'len1';
export const BAR_SCHEMATIC_PARAM_CEMENT_GAP = 'cementGap';
export const BAR_SCHEMATIC_PARAM_MARGIN_GAP = 'marginGap';

// CAD Plane Cut Constants
export const DEFAULT_PLANE_CUT_NAME = 'cutPlane1';

// CAD Viewer Type Translation Keys
export const VIEWER_TITLE_KEY_BAR = 'BAR_VIEWER';
export const VIEWER_TITLE_KEY_CROWN = 'CROWN_VIEWER';
export const VIEWER_TITLE_KEY_CAD = 'CAD_VIEWER';

// CAD parameter unit tooltip keys
export const I18N_KEY_UNIT_DEGREE = 'UNIT_DEGREE';
export const I18N_KEY_UNIT_MM = 'UNIT_MM';
export const I18N_KEY_UNIT_PERCENT = 'UNIT_PERCENT';

// CAD Viewer Axis Presets
export const VIEWER_AXIS_LIST = ['+X', '+Y', '+Z', '-X', '-Y', '-Z'] as const;
export type ViewerAxis = typeof VIEWER_AXIS_LIST[number];
export const VIEWER_DEFAULT_AXIS: ViewerAxis = VIEWER_AXIS_LIST[0];

// CAD View Toolbar variants
export const VIEW_TOOLBAR_VARIANT_DEFAULT = 'default';
export const VIEW_TOOLBAR_VARIANT_MOBILE_RAIL = 'mobile-rail';

/**
 * Paket ismini dinamik olarak uygulama ismine dönüştürür (clinic, lab, cad)
 * @param packageName - Abonelikten gelen paket ismi
 * @returns Uygulama ismi (clinic, lab, cad) veya null
 */
export function mapPackageNameToAppName(packageName: string): string | null {
  if (!packageName) {
    return null;
  }

  const lowerPackageName = packageName.toLowerCase();

  if (lowerPackageName.includes('clinic')) {
    return CLINIC_APP_NAME;
  }

  if (lowerPackageName.includes('lab') || lowerPackageName.includes('laboratory')) {
    return LAB_APP_NAME;
  }

  // Bar Free / Bar Studio / Autobar → Lab app (design projects / Autobar)
  if (
    lowerPackageName.includes('bar') ||
    lowerPackageName.includes('autobar') ||
    lowerPackageName.includes('studio')
  ) {
    return LAB_APP_NAME;
  }

  if (lowerPackageName.includes('cad') || lowerPackageName.includes('cam') || lowerPackageName.includes('cadcam')) {
    return CAD_APP_NAME;
  }

  return null;
}

/** Short UI tick (viewer paint wait, wizard step restore, etc.). */
export const DELAY_150_MS = 150;

/** Document Visibility API states (background-tab rAF polyfill / WASM init). */
export const DOCUMENT_VISIBILITY_STATE_HIDDEN = 'hidden';
export const DOCUMENT_VISIBILITY_STATE_VISIBLE = 'visible';

/** ~60fps tick while rAF is remapped to setTimeout in hidden tabs. */
export const BACKGROUND_RAF_HIDDEN_FRAME_MS = 16;

/** Idempotent install guard on window for CAD background rAF polyfill. */
export const BACKGROUND_RAF_POLYFILL_INSTALL_FLAG = '__dentalBackgroundRafPolyfillInstalled';

// 3D Viewer UI Initialization Delays
export const VIEWER_FONT_LOAD_TIMEOUT_MS = 1500;
export const VIEWER_INITIAL_LOAD_MIN_WAIT_MS = 400;
export const VIEWER_INITIAL_LOAD_MAX_TIMEOUT_MS = 10000;

// CAD Error & Status Constants
export const WASM_RESPONSE_STATUS_SUCCESS = '0';
export const WASM_RESPONSE_STATUS_ERROR = '1';
export const STEP_SAFETY_TIMEOUT_MS = 20000;

// CAD Error Translation Keys
export const ERROR_KEY_EXTRUDE_FAILED = 'ERROR_EXTRUDE_FAILED';
export const ERROR_KEY_GENERATE_FAILED = 'ERROR_GENERATE_FAILED';
export const ERROR_KEY_TIMEOUT = 'ERROR_TIMEOUT';
export const ERROR_KEY_WORKER_INTERNAL = 'ERROR_WORKER_INTERNAL';
export const ERROR_KEY_INTERNAL_COMMAND = 'ERROR_INTERNAL_COMMAND';
export const ERROR_KEY_COMMAND_PREPARATION = 'ERROR_COMMAND_PREPARATION';

// Bar Creation Wizard Step Keys
export const BAR_WIZARD_STEP_KEY_DRAW = 'draw';
export const BAR_WIZARD_STEP_KEY_APPLY = 'apply';
export const BAR_WIZARD_STEP_KEY_GENERATE = 'generate';
export const BAR_WIZARD_STEP_KEY_SPLIT = 'split';

// Bar Creation Wizard Translation Keys
export const BAR_WIZARD_LABEL_DRAW = 'DRAW';
export const BAR_WIZARD_LABEL_APPLY = 'APPLY';
export const BAR_WIZARD_LABEL_GENERATE = 'GENERATE_SURFACE';
export const BAR_WIZARD_LABEL_SPLIT = 'SPLIT';
export const BAR_WIZARD_TUTORIAL_DRAW = 'DRAW_BOUNDARY_CURVE_TUTORIAL';
export const BAR_WIZARD_TUTORIAL_APPLY = 'APPLY_TUTORIAL';
export const BAR_WIZARD_TUTORIAL_GENERATE = 'GENERATE_SURFACE_TUTORIAL';
export const BAR_WIZARD_TUTORIAL_GENERATE_HINT = 'GENERATE_SURFACE_TUTORIAL_HINT';
export const BAR_WIZARD_TUTORIAL_GENERATE_PARAM_LINK = 'GENERATE_SURFACE_PARAM_LINK';
export const BAR_WIZARD_TUTORIAL_GENERATE_IF_NEEDED = 'IF_NEEDED';
export const BAR_WIZARD_TUTORIAL_SPLIT = 'SPLIT_TUTORIAL';
export const BAR_DESIGNER_TITLE = 'BAR_DESIGNER';
export const BAR_ACTION_CANCEL = 'CANCEL';
export const BAR_ACTION_SAVED = 'SAVED';
export const FILES_SELECTED_COUNT_KEY = 'FILES_SELECTED_COUNT';

// Bar Confirmation Dialog Translation Keys
export const CONFIRM_KEY_DELETE_CURVE_TITLE = 'CONFIRM_DELETE_CURVE_TITLE';
export const CONFIRM_KEY_DELETE_CURVE_MSG = 'CONFIRM_DELETE_CURVE_MSG';
export const CONFIRM_KEY_YES = 'CONFIRM_YES';
export const CONFIRM_KEY_NO = 'CONFIRM_NO';

// CAD Common Confirmation & Action Dialog Translation Keys
export const CONFIRM_KEY_SAVE_TITLE = 'CONFIRM_SAVE_TITLE';
export const CONFIRM_KEY_SAVE_MSG = 'CONFIRM_SAVE_MSG';
export const CONFIRM_KEY_SAVE = 'SAVE';
export const CONFIRM_KEY_CLOSE = 'CLOSE';
export const CONFIRM_KEY_SHARE = 'SHARE';
export const CONFIRM_KEY_SHARE_MSG = 'CONFIRM_SHARE_MSG';
export const DIALOG_KEY_SHARE_DESIGN = 'SHARE_DESIGN';
export const DIALOG_KEY_SHARE_DESIGN_SUBTITLE = 'SHARE_DESIGN_SUBTITLE';
export const DIALOG_KEY_SHARE_PROJECT = 'SHARE_PROJECT';
export const DIALOG_KEY_SHARE_PROJECT_SUBTITLE = 'SHARE_PROJECT_SUBTITLE';
export const BUTTON_KEY_CREATE_LINK = 'CREATE_LINK';
export const BUTTON_KEY_COPY_LINK = 'COPY_LINK';
export const BUTTON_KEY_COPIED = 'COPIED';
export const DIALOG_KEY_EXPORT = 'EXPORT';
export const LABEL_KEY_SELECT_ALL = 'SELECT_ALL';
export const CONFIRM_KEY_DELETE_MODEL_TITLE = 'CONFIRM_DELETE_MODEL_TITLE';
export const CONFIRM_KEY_DELETE_MODEL_MSG = 'CONFIRM_DELETE_MODEL_MSG';

// CAD Toast & Notification Translation Keys
export const TOAST_KEY_COPY_SUCCESS = 'COPY_SUCCESS';
export const TOAST_KEY_SHARE_ERROR = 'SHARE_ERROR';
export const TOAST_KEY_SHARE_SUCCESS = 'SHARE_SUCCESS';
export const TOAST_KEY_SAVE_SUCCESS = 'SAVE_SUCCESS';
export const TOAST_KEY_SAVE_ERROR = 'SAVE_ERROR';
export const TOAST_KEY_FILE_LOADED_SUCCESS = 'FILE_LOADED_SUCCESS';
export const TOAST_KEY_FILE_REMOVED_SUCCESS = 'FILE_REMOVED_SUCCESS';
export const TOAST_KEY_SELECT_THREE_POINTS =
  'SELECT_THREE_POINTS_TO_DEFINE_PLANE';

// CAD Additional Error Translation Keys
export const ERROR_KEY_PROJECT_ID_NOT_FOUND = 'ERROR_PROJECT_ID_NOT_FOUND';
export const ERROR_KEY_PROJECT_NOT_FOUND_OR_DELETED = 'PROJECT_NOT_FOUND_OR_DELETED';
export const ERROR_KEY_FAILED_TO_INITIALIZE_3D_VIEWER = 'FAILED_TO_INITIALIZE_3D_VIEWER';
export const ERROR_KEY_READING_FILE = 'ERROR_READING_FILE';

// CAD Bar Tools & Deform Translation Keys
export const BAR_GEO_LABEL_SETTINGS = 'SETTINGS';
export const BAR_GEO_LABEL_TARGET_MESH = 'TARGET_MESH';
export const BAR_GEO_LABEL_BRUSH = 'BRUSH';
export const BAR_GEO_LABEL_BRUSH_SIZE = 'BRUSH_SIZE';
export const BAR_GEO_LABEL_STRENGTH = 'STRENGTH';
export const BAR_GEO_LABEL_MINIMUM_THICKNESS = 'MINIMUM_THICKNESS';
export const BAR_GEO_LABEL_APPLY_SAFETY_ZONE = 'APPLY_SAFETY_ZONE';
export const BAR_GEO_LABEL_PLANE_CUT = 'PLANE_CUT';
export const BAR_GEO_LABEL_ADD_PLANE = 'ADD_PLANE';
export const BAR_GEO_LABEL_CUT = 'CUT';
export const BAR_GEO_LABEL_INFLATE = 'INFLATE';
export const BAR_GEO_LABEL_SUBTRACT = 'SUBTRACT';
export const BAR_GEO_LABEL_SMOOTH = 'SMOOTH';
export const BAR_GEO_LABEL_GRAB = 'GRAB';
export const BAR_GEO_LABEL_HIDE = 'HIDE';
export const BAR_GEO_LABEL_SHOW = 'SHOW';
export const BAR_GEO_LABEL_ADD_CONE = 'ADD_CONE';
export const BAR_GEO_LABEL_DELETE_CONE = 'DELETE_CONE';

// CAD Timing, Storage & Cookie Constants
export const TUTORIAL_AUTO_DISMISS_DELAY_MS = 5000;
export const STORAGE_KEY_SAVED_JSON_LIST = 'savedJSONList';
export const STORAGE_KEY_DEV_CONSOLE_COMMAND = 'devConsoleCommand';
export const FILE_EXTENSION_JSON = '.json';

// CAD Navigation Routes
export const ROUTE_LAB_DESIGN_PROJECT = `/${LAB_APP_NAME}/designproject`;

/**
 * API MouseControlEnum string members (UserSettings Put/Get).
 * Legacy numeric: Default=1, Exocad=2, 3Shape=3 — still accepted on read.
 */
export const MOUSE_CONTROL_DEFAULT = 'Default';
export const MOUSE_CONTROL_EXOCAD = 'Exocad';
export const MOUSE_CONTROL_3SHAPE = '3Shape';

export type MouseControlValue =
  | typeof MOUSE_CONTROL_DEFAULT
  | typeof MOUSE_CONTROL_EXOCAD
  | typeof MOUSE_CONTROL_3SHAPE;

export const I18N_SETTINGS_MOUSE_CONTROLS = 'SETTINGS.MOUSE_CONTROLS';
export const I18N_SETTINGS_MOUSE_CONTROLS_DEFAULT = 'SETTINGS.MOUSE_CONTROLS_DEFAULT';
export const I18N_SETTINGS_MOUSE_CONTROLS_EXOCAD = 'SETTINGS.MOUSE_CONTROLS_EXOCAD';
export const I18N_SETTINGS_MOUSE_CONTROLS_3SHAPE = 'SETTINGS.MOUSE_CONTROLS_3SHAPE';

/** API / UI / legacy numeric değerlerini MouseControl string enum'una normalize eder. null/undefined → Default. */
export function normalizeMouseControl(raw: unknown): MouseControlValue {
  if (raw === null || raw === undefined) {
    return MOUSE_CONTROL_DEFAULT;
  }

  if (
    raw === MOUSE_CONTROL_DEFAULT ||
    raw === MOUSE_CONTROL_EXOCAD ||
    raw === MOUSE_CONTROL_3SHAPE
  ) {
    return raw;
  }

  if (typeof raw === 'number') {
    if (raw === 1) return MOUSE_CONTROL_DEFAULT;
    if (raw === 2) return MOUSE_CONTROL_EXOCAD;
    if (raw === 3) return MOUSE_CONTROL_3SHAPE;
  }

  if (typeof raw === 'string') {
    const trimmed = raw.trim();
    const upper = trimmed.toUpperCase();

    if (trimmed === MOUSE_CONTROL_DEFAULT || upper === 'DEFAULT' || trimmed === '1') {
      return MOUSE_CONTROL_DEFAULT;
    }

    if (trimmed === MOUSE_CONTROL_EXOCAD || upper === 'EXOCAD' || trimmed === '2') {
      return MOUSE_CONTROL_EXOCAD;
    }

    if (
      trimmed === MOUSE_CONTROL_3SHAPE ||
      upper === '3SHAPE' ||
      upper === '_3SHAPE' ||
      upper === 'THREESHAPE' ||
      trimmed === '3'
    ) {
      return MOUSE_CONTROL_3SHAPE;
    }
  }

  return MOUSE_CONTROL_DEFAULT;
}

/** Branch.type / UserForRegisterDto.BranchType */
export const BRANCH_TYPE_CLINIC = 1;
export const BRANCH_TYPE_LAB = 2;

/** UserForRegisterDto.Type default for Autobar self-registration */
export const USER_REGISTER_TYPE_DEFAULT = 0;

/** UserForRegisterDto.ModifiedBy default for self-registration */
export const USER_REGISTER_MODIFIED_BY_DEFAULT = 0;

/** Team product-access label for the assignable Autobar seat (paid plan). */
export const BAR_DESIGNER_PLAN_NAME = 'Autobar';
/** Team product-access product id for the assignable Autobar seat. */
export const BAR_DESIGNER_PRODUCT_ID = BAR_DESIGNER_PLAN_NAME.toLowerCase();
/** CAD hash route for crown / veneer viewer — no leading slash. */
export const CAD_CROWN_VIEWER_ROUTE_PATH = 'crown-viewer';

/** Sidebar brand logo assets (account / lab layouts). */
export const AUTOBAR_LOGO_PATH = 'assets/autobar_logo.png';
export const AUTOBAR_LOGO_MINI_PATH = 'assets/autobar_logo_mini.png';
export const AUTOBAR_TEXT_LOGO_PATH = 'assets/autobar_text_logo.png';

/** i18n keys for layout brand alt text */
export const I18N_ACCOUNT_LAYOUT_BRAND_TITLE = 'ACCOUNT_LAYOUT.BRAND_TITLE';
export const I18N_LAB_LAYOUT_BRAND_TITLE = 'LAB_LAYOUT.BRAND_TITLE';

/**
 * Placeholder card payload for Subscription/Subscribe until real payment UI is wired.
 * Not user-facing copy — API contract fields only.
 */
export const DEFAULT_SUBSCRIBE_CARD = {
  cardName: 'Test Card',
  cardNumber: '8001044245869854',
  expiredDate: '12/99',
  cvv: '234',
} as const;

/** Team page: client-side product access map (until backend API exists). */
export const TEAM_PRODUCT_ACCESS_STORAGE_KEY = 'dentalui.team.productAccess';

/** Fallback when an Error has no message (state/API catch paths). */
export const GENERIC_ERROR_MESSAGE = 'An error occurred';

/** Default pagination sort order when synthesizing a list response. */
export const SORT_ORDER_ASC = 'asc';

/** Empty JSON object string — used to detect blank design-project details. */
export const EMPTY_JSON_OBJECT = '{}';

/** Lab design-project filter: include sample projects by default. */
export const DESIGN_PROJECT_FILTER_IS_SAMPLE_DEFAULT = true;

/** Keys used to detect a subscription DTO / list payload from Subscribe responses. */
export const SUBSCRIPTION_DTO_KEY_DATA = 'data';
export const SUBSCRIPTION_DTO_KEY_PACKAGE_NAME = 'packageName';
export const SUBSCRIPTION_DTO_KEY_PACKAGE_NAME_PASCAL = 'PackageName';
export const SUBSCRIPTION_DTO_KEY_ID = 'id';
export const SUBSCRIPTION_DTO_KEY_ID_PASCAL = 'Id';

